import { TitleFull as Title } from '@warehouse/title/core';
import { editUuid, episodeUuid, manifestationUuid, seasonUuid } from '@warehouse/title/infra';

export function shouldDisplayGoToParentButton(title: Title) {
	const { workType } = title.metadata.coreMetadata.basic;
	return [episodeUuid(), seasonUuid(), editUuid(), manifestationUuid()].includes(workType);
}
